const fonts = {
  body: "Urbane",
  heading: "Beatrice",
  headingMedium: "Urbane",
};

const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  mediumBold: 600,
  bold: 700,
  heavy: 800,
};

const fontSizes = {
  small: "10px",
  label: "12px",
  body: "14px",
  large: "16px",
  h5: "18px",
  h4: "20px",
  h3: "26px",
  h2: "32px",
  h1: "56px",
};

export { fonts, fontWeights, fontSizes };
